import { cn } from '@exam-room/utils';

interface CardSkeletonProps extends React.ComponentProps<'div'> {
  size?: 'sm' | 'md' | 'lg';
}

//TODO: Implement size prop
export default function CardSkeleton({ className, ...props }: CardSkeletonProps) {
  return (
    <div
      className={cn(['flex animate-pulse flex-col rounded-2xl bg-slate-200 p-6', className])}
      {...props}
    />
  );
}
